<script lang="ts">
	import { EditionsPDP } from '#lib/websites/editions/pages/EditionsPDP/index.js';
</script>

<EditionsPDP />
